<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)" :disabled="deshabilitado">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un estatus del trámite de cita</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus de los trámites de citas</option>
        <option v-for="TipoEstatusDeTramiteCita in TiposEstatusDeTramitesCitas" :value="TipoEstatusDeTramiteCita.TipoEstatusDeTramiteCitaId" :key="TipoEstatusDeTramiteCita.TipoEstatusDeTramiteCitaId">{{TipoEstatusDeTramiteCita.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposEstatusDeTramitesCitas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      
      this.$store.dispatch("A_SICCIJ_Catalogo_Establecer014TipoEstatusDeTramiteCita", parametros);
    },
    methods: {
      cargaCatalogoTiposEstatusDeTramitesCitas() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      
                
        axios.post(api.conexion + api.SICCIJ.catalogos.C001TiposEstatusDeTramitesCitas, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.TiposEstatusDeTramitesCitas = respuesta.data.TiposEstatusDeTramitesCitas;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.TiposEstatusDeTramitesCitas = respuesta.data.TiposEstatusDeTramitesCitas.filter(cond => this.parametros.filtros.some(tipo => tipo == cond.TipoEstatusDeTramiteCitaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_SICCIJ_Catalogo_Establecer014TipoEstatusDeTramiteCita", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposEstatusDeTramitesCitas();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Comun/Catalogos/014TiposEstatusDeTramitesCitas.vue